import React, {useState} from 'react';
import {Store} from '../../models/store.model';
import {AppText, AppCardTitle, AppBodyText, AppLabelText, AppSubtitle} from '../../../../Presentation/components/ui/Typography';
import {CreditInfoCard} from '../cards/CreditInfoCard';
import {EditCreditLimitModal} from '../modals/EditCreditLimitModal';
import {useStoreSelectionStore} from '../../store/StoreSelectionStore';

interface StoreFinancialInfoProps {
  store: Store;
}

export const StoreFinancialInfo: React.FC<StoreFinancialInfoProps> = ({store}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const {fetchStoreDetails, selectedStoreDetails} = useStoreSelectionStore();

  // Use selectedStoreDetails if available (updated data), otherwise use prop
  const displayStore = selectedStoreDetails && selectedStoreDetails.id === store?.id
    ? selectedStoreDetails
    : store;

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  const handleEditSuccess = () => {
    // Refresh store details to get updated credit info
    if (store?.id) {
      fetchStoreDetails(store.id.toString());
    }
  };

  if (displayStore?.creditInfo) {
    return (
      <>
        <div className="space-y-4">
          <CreditInfoCard
            creditInfo={displayStore.creditInfo}
            storeId={displayStore.id}
            onEditClick={handleEditClick}
          />
        </div>

        {showEditModal && (
          <EditCreditLimitModal
            isOpen={showEditModal}
            onClose={() => setShowEditModal(false)}
            storeId={displayStore.id}
            currentCreditLimit={displayStore.creditInfo.creditLimit || 0}
            onSuccess={handleEditSuccess}
          />
        )}
      </>
    );
  }

  return (
    <div className="space-y-4">
      <AppCardTitle className="border-b pb-2">المعلومات المالية</AppCardTitle>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gray-50 p-4 rounded-lg">
          <AppLabelText className="text-gray-600 mb-1">إجمالي المبيعات</AppLabelText>
          <AppCardTitle className="font-bold text-green-600">
            غير متوفر
          </AppCardTitle>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <AppLabelText className="text-gray-600 mb-1">المبلغ المستحق</AppLabelText>
          <AppCardTitle className="font-bold text-red-600">
            غير متوفر
          </AppCardTitle>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <AppLabelText className="text-gray-600 mb-1">آخر دفع</AppLabelText>
          <AppBodyText className="font-medium">
            لا يوجد
          </AppBodyText>
        </div>
      </div>
    </div>
  );
};


